import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Dropdown,
} from 'reactstrap';
import { Auth } from 'aws-amplify';
import { withRouter } from 'react-router-dom';

class HeaderDropdown extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      dropdownOpen: false,
    };
    this._logOut = this._logOut.bind(this);
  }

  toggle() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
    });
  }
  _logOut() {
    Auth.signOut().then(() => this.props.history.push('/login'));
  }

  dropAccnt() {
    return (
      <Dropdown nav isOpen={this.state.dropdownOpen} toggle={this.toggle}>
        <DropdownToggle nav>
          <img src="img/avatars/1.jpg" className="img-avatar" alt="admin@bootstrapmaster.com" />
        </DropdownToggle>
        <DropdownMenu right>
          <DropdownItem onClick={this._logOut}><i className="fa fa-lock" /> Logout</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    );
  }

  render() {
    // const { ...attributes } = this.props;
    return (
      this.dropAccnt()
    );
  }
}
HeaderDropdown.propTypes = {
  history: PropTypes.shape().isRequired,
};
export default withRouter(HeaderDropdown);



// WEBPACK FOOTER //
// ./src/components/MenuBar/HeaderDropdown.js